

const translations = {
    en: {
      about:"About",
      problem:"Problem",
      solution:"Solution",
      challenge:"Challenge",
      features:"Features",
      impact:"Impact",
      join:"Join",
      contactTo:"Contact",
      header: "Revolutionize Emergency Cardiac Training—Save More Lives",
      subHeader: "Advanced and Accessible Software to Train Healthcare Heroes",
      installNow: "Download Resus Now",
      contactNow: "Follow the news",
      followTheNews:"Follow the news and the launch of our application",
      problemTitle: "A Global Health Emergency",
      problemText: [
        "Every year, over 400,000 people worldwide lose their lives to cardiovascular emergencies.",
        "In Brazil alone, 200,000 lives are lost annually.",
        "Despite progress in basic life support, gaps in advanced training for healthcare professionals remain a critical issue."
      ],
      problemResult : "<strong>The result?</strong> Unnecessary fatalities that could be prevented with better preparedness and up-to-date training.",
      challengesTitle: "Why aren't current solutions enough?",
      challengesList: [
        "<b>Game-based Apps :</b> Slow to update medical protocols, limiting their effectiveness.",
        "<b>Apollo Simulator :</b> Expensive, requires dedicated hardware and specialized operators.",
        "<b>Dart Sim App :</b> Apple-only, high equipment costs, and a non-user-friendly interface."
      ],
      challengesBottomLine : "<strong>Bottom line:</strong> Existing options are either too costly, too complicated, or lag behind the latest clinical guidelines.",
      solutionTitle: "The Solution: Resus",
      solutionText: "Introducing <b>Resus</b>, the next-generation software for emergency cardiac training.",
      solutionList : [
        "<b>Comprehensive Modules</b>: Exclusive CPR training, quick notes, and more—right at your fingertips.",
        "<b>Realistic Features</b>: Advanced simulations ensure practice feels as close to real-life emergencies as possible."
      ],
      featuresTitle: "Why choose our app?",
      featuresList: [
        "<b>CPR & AED Module (Android-Exclusive) :</b> Train effectively on the devices you already own.",
        "<b>Fine VF Simulation :</b> Hone your skills with cutting-edge, precise arrhythmia simulations.",
        "<b>Intuitive Interface :</b> No steep learning curve—focus on building life-saving skills.",
        "<b>Affordable & Accessible :</b> No need for specialized hardware or prohibitively priced equipment."
      ],
      impactTitle: "Revolutionizing Medical Training",
      impactText: [
        "<b>Save More Lives</b>",
        "Empower your healthcare teams with modern, hands-on training tools that prepare them for real-world cardiac emergencies.",
        "",
        "<b>Tailored to Every Setting</b>",
        "Whether you’re in a high-tech hospital or a small clinic, Cardio Workbench seamlessly adapts to your environment—bridging critical training gaps and making advanced emergency care a reality for all.",
      ],
      ctaTitle:"Join the Revolution in Emergency Cardiac Training",
      ctaList:[
        "By choosing <b>Resus</b>, you’re not just getting another training tool—you’re joining a movement to raise the global standard of cardiac emergency readiness. Get prepared, save lives, and shape the future of medical training!"
      ],
      contact: "Contact us: ",
      email:"contact@resusapp.com",
      followUs: "Follow us on social media:",
      comingSoon: "Available for Android phones and tablets",
      
      details: [
        {
          section: "Advanced Simulation Features",
          subsections: [
            {name: "12 Heart Rhythms",
              items : ["Master ECG interpretations with realistic and varied scenarios."]
            },
            {name: "4 SpO2 Curve Models",
              items : ["Adjust and monitor different saturation patterns for each type of patient."]
            },
            {name: "3 Blood Pressure Models (ABP)",
              items : ["Practice handling varying pressures and learn to react quickly to dynamic changes."]
            },
            {name: "Adjustable EtCO2 and Respiratory Rate (RR)",
              items : ["Accurately simulate ventilation and perfusion conditions."]
            },
          ]
        },
        {
          section: "Essential Intervention Functions",
          subsections: [
            {name: "Defibrillator",
              items : [
                "Adjust shock energy as per protocol and refine your technique.",
                "Synchronized Cardioversion",
                "Charging and Grounding Mechanism",
                "Responsive Shock on ECG",
                "Energy Setting: 50–360 Joules"
              ]
            },
            {name: "Pacemaker",
              items : [
                "Practice using a transcutaneous pacemaker in realistic scenarios.",
                "Beat setting: 0-200 bpm",
                "Current setting: 0-150 mA"
              ]
            },
            {name: "CPR Function",
              items : ["Chest massage simulation."]
            },
            {name: "NIB Function",
              items : ["Monitor non-invasive blood pressure quickly and conveniently."]
            },
            {name: "Medicines",
              items : ["38 medicines available."]
            },
          ]
        },
        {
          section: "Full Control of Scenario and Other Features",
          subsections: [
            {name: "Create Your Own Scenarios",
              items : ["Completely customize the simulation environment to reflect real situations from your day-to-day professional life."]
            },
            {name: "Adjust All Vital Signs",
              items : ["Easily configure parameters such as heart rate, blood pressure, saturation, among others, for each clinical case."]
            },
            {name: "Custom Alarms",
              items : ["Quickly identify risk signals and improve team response time."]
            },
            {name: "Reset Button",
              items : ["Quick reset to default application settings."]
            },
            {name: "Event Log",
              items : ["Easily review actions taken during the simulation and identify opportunities for improvement."]
            },
          ]
        }
      ],
      carouselsub:'Resus is a real-time vital signs simulator designed for training healthcare professionals and teams in clinical and emergency scenarios. ',
      carousel:[
        "<strong>Displays vital signs and waveforms:</strong> Heart rate (HR), oxygen saturation (SpO2), invasive blood pressure (ABP), capnography (ETCO2) and their waveforms, faithfully replicating a patient monitor in real resuscitation situations.",
        "<strong>Pathology Models:</strong> Includes numerous pathology waveform models, allowing simulation of a wide variety of clinical scenarios.",
        "<strong>Advanced Features:</strong>",
        [
          "Defibrillator, Pacemaker, and CPR: Essential tools for advanced life support training.",
          "Medication and Alarms: Simulates physiological responses to medications and audible alerts for critical situations.",
          "Realistic Sounds: Emulates the sounds of real medical devices for greater immersion in training."],
        "<strong>Event log:</strong> Records all actions performed during the simulation, facilitating debriefing and performance analysis.",
        "<strong>Reset button:</strong> Allows you to quickly restart new scenarios, optimizing training time.",
        "<strong>Availability:</strong> Available for Android cell phones and tablets, offering practicality and accessibility for healthcare professionals."
      ],
      googleform:['Name*','Profession','Specialty','Company','Phone','Email*','Comments/ Suggestions/ Requests']
    },
    pt: {
      about:"Sobre",
      problem:"Problema",
      solution:"Solução",
      challenge:"Desafio",
      features:"Funcionalidades",
      impact:"Impacto",
      join:"Junte-se",
      contactTo:"Contato",
      header: "Revolucione o treinamento cardíaco de emergência — salve mais vidas",
      subHeader: "Software avançado e acessível para treinar heróis da saúde",
      installNow: "Baixe o Resus agora",
      contactNow: "Acompanhe as novidades",
      followTheNews:"Acompanhe as novidades e o lançamento do nosso aplicativo",
      problemTitle: "Uma Emergência Global de Saúde",
      problemText: [
        "Todos os anos, mais de 400.000 pessoas no mundo perdem suas vidas em emergências cardiovasculares.",
        "Só no Brasil, 200.000 vidas são perdidas anualmente.",
        "Apesar do progresso no suporte básico de vida, as lacunas no treinamento avançado para profissionais de saúde continuam sendo um problema crítico."
      ],
      problemResult: "<strong>O resultado?</strong> Mortes desnecessárias que poderiam ser evitadas com melhor preparação e treinamento atualizado.",
      challengesTitle: "Por que as soluções atuais não são suficientes?",
      challengesList: [
        "<b>Aplicativos baseados em jogos:</b> Lento para atualizar protocolos médicos, limitando sua eficácia.",
        "<b>Simulador Apollo:</b> Caro, requer hardware dedicado e operadores especializados.",
        "<b>Aplicativo Dart Sim:</b> Somente para Apple, altos custos de equipamento e uma interface não amigável."
      ],
      challengesBottomLine: "<strong>Conclusão:</strong> As opções existentes são muito caras, muito complicadas ou ficam aquém das diretrizes clínicas mais recentes.",
      solutionTitle: "A solução: Resus",
      solutionText: "Apresentando o <b>Resus</b>, o software de última geração para treinamento cardíaco de emergência.",
      solutionList : [
        "<b>Módulos abrangentes</b>: treinamento exclusivo de RCP, notas rápidas e muito mais — na ponta dos seus dedos.",
        "<b>Recursos realistas</b>: simulações avançadas garantem que a prática pareça o mais próxima possível de emergências da vida real."
      ],
      featuresTitle: "Por que escolher o nosso app?",
      featuresList: [
        "<b>Módulo de RCP e DEA (exclusivo para Android):</b> Treine efetivamente nos dispositivos que você já possui.",
        "<b>Simulação fina de VF:</b> Aprimore suas habilidades com simulações de arritmia precisas e de ponta.",
        "<b>Interface intuitiva:</b> Nenhuma curva de aprendizado íngreme — concentre-se em desenvolver habilidades para salvar vidas.",
        "<b>Acessível e disponível:</b> Não há necessidade de hardware especializado ou equipamento com preço proibitivo."
      ],
      impactTitle: "Revolução no Treinamento Médico",
      impactText: [
        "<b>Salve Mais Vidas</b>",
        "Capacite suas equipes de saúde com ferramentas de treinamento modernas e práticas que as preparam para emergências cardíacas do mundo real.",
        "",
        "<b>Ajustado para Cada Ambiente</b>",
        "Esteja você em um hospital de alta tecnologia ou em uma pequena clínica, o Cardio Workbench se adapta perfeitamente ao seu ambiente, preenchendo lacunas críticas de treinamento e tornando o atendimento de emergência avançado uma realidade para todos.",
      ],
      ctaTitle:"Junte-se à Revolução no Treinamento Cardíaco de Emergência",
      ctaList:[
        "Ao escolher <b>Resus</b>, você não está apenas adquirindo outra ferramenta de treinamento, você está se juntando a um movimento para elevar o padrão global de prontidão para emergências cardíacas. Prepare-se, salve vidas e molde o futuro do treinamento médico!"
      ],
      contact: "Entre em contato: ",
      email:"contact@resusapp.com",
      followUs: "Siga-nos nas redes sociais:",
      comingSoon: "Disponível para celulares e tablets Android",

      details: [
        {
          section: "Recursos Avançados de Simulação",
          subsections: [
            {name: "12 Ritmos Cardíacos",
              items : ["Domine interpretações de ECG com cenários realistas e variados."]
            },
            {name: "4 Formas de Curva SpO2",
              items : ["Ajuste e monitore diferentes padrões de saturação para cada tipo de paciente."]
            },
            {name: "3 Modelos de Pressão Arterial (ABP)",
              items : ["Pratique o manejo de pressões variadas e aprenda a reagir rapidamente a mudanças dinâmicas."]
            },
            {name: "Taxas de EtCO2 e Frequência Respiratória (RR) Ajustáveis",
              items : ["Simule condições de ventilação e perfusão com precisão."]
            },
          ]
        },
        {
          section: "Funções Essenciais de Intervenção",
          subsections: [
            {name: "Desfibrilador",
              items : [
                "Ajuste a energia de choque conforme o protocolo e refine sua técnica.",
                "Cardioversão Sincronizada",
                "Mecanismo de carregamento e aterramento",
                "Choque responsivo no ECG",
                "Ajuste de energia : 50–360 Joules"
              ]
            },
            {name: "Marcapasso",
              items : [
                "Pratique o uso de marcapasso transcutâneo em cenários realistas.",
                "Ajuste de batimentos : 0-200 bpm",
                "Ajuste de corrente : 0-150 mA"
              ]
            },
            {name: "Função CPR",
              items : ["Simulação de massagem torácica."]
            },
            {name: "Função NIB",
              items : ["Monitore a pressão arterial não invasiva de maneira rápida e prática."]
            },
            {name: "Medicamentos",
              items : ["38 medicamentos disponíveis."]
            },
          ]
        },
        {
          section: "Controle Total do Cenário e Outros Recursos",
          subsections: [
            {name: "Crie Seus Próprios Cenários",
              items : ["Personalize completamente o ambiente de simulação para refletir situações reais do seu dia a dia profissional."]
            },
            {name: "Ajuste Todos os Sinais Vitais",
              items : ["Configure facilmente parâmetros como frequência cardíaca, pressão arterial, saturação, dentre outros, para cada caso clínico."]
            },
            {name: "Alarmes Personalizados",
              items : ["Identifique rapidamente sinais de risco e melhore o tempo de resposta da equipe."]
            },
            {name: "Botão de Reset",
              items : ["Reinicio rápido das configurações padrão do aplicativo."]
            },
            {name: "Log de Eventos",
              items : ["Revise facilmente as ações tomadas durante a simulação e identifique oportunidades de melhoria."]
            },
          ]
        }
      ],
      carouselsub:'Resus é um simulador de sinais vitais em tempo real, desenvolvido para o treinamento de profissionais e equipes de saúde em cenários clínicos e de emergência.',
      carousel:[
        "<strong>Exibe sinais vitais e formas de onda:</strong> Frequência cardíaca (HR), saturação de oxigênio (SpO2), pressão arterial invasiva (ABP), capnografia (ETCO2) e suas formas de onda, replicando fielmente um monitor de paciente em situações reais de reanimação.",
        "<strong>Modelos de patologias:</strong> Inclui inúmeros modelos de patologias para formas de onda, permitindo a simulação de uma ampla variedade de cenários clínicos.",
        "<strong>Funcionalidades avançadas:</strong>",
        [
          "Desfibrilador, marcapasso e CPR: Ferramentas essenciais para treinamento em suporte avançado de vida.",
          "Medicamentos e alarmes: Simula respostas fisiológicas a medicamentos e alertas sonoros para situações críticas.",
          "Sons realistas: Emula os sons de dispositivos médicos reais para maior imersão no treinamento."],
        "<strong>Log de eventos:</strong> Registra todas as ações realizadas durante a simulação, facilitando o debriefing e a análise de desempenho.",
        "<strong>Botão de reset:</strong> Permite reiniciar rapidamente novos cenários, otimizando o tempo de treinamento.",
        "<strong>Disponibilidade:</strong> Disponível para celulares e tablets Android, oferecendo praticidade e acessibilidade para profissionais de saúde."
      ],
      googleform:['Nome*','Profissão','Especialidade','Empresa','Telefone','Email*','Comentários/ Sugestões/ Solicitações']
    },
    es: {
      about:"Acerca",
      problem: "Problema",
      solution: "Solución",
      challenge: "Desafío",
      features: "Funcionalidades",
      impact: "Impacto",
      join:"Unirse",
      contactTo: "Contacto",
      header: "Revolucione la capacitación en emergencias cardíacas: salve más vidas",
      subHeader: "Software avanzado y accesible para capacitar a los héroes de la atención médica",
      installNow: "Descargue Resus ahora",
      contactNow: "Sigue las novedades",
      followTheNews:"Sigue las novedades y lanzamiento de nuestra app",
      problemTitle: "Una Emergencia Mundial de Salud",
      problemText: [
        "Cada año, más de 400.000 personas en todo el mundo pierden la vida por emergencias cardiovasculares.",
        "Solo en Brasil, se pierden 200.000 vidas al año.",
        "A pesar de los avances en el soporte vital básico, las deficiencias en la formación avanzada de los profesionales sanitarios siguen siendo un problema crítico."
      ],
      problemResult : "<strong>¿El resultado?</strong> Muertes innecesarias que podrían evitarse con una mejor preparación y una formación actualizada.",
      challengesTitle: "¿Por qué las soluciones actuales no son suficientes?",
      challengesList: [
        "<b>Aplicaciones basadas en juegos:</b> Los protocolos médicos se actualizan con lentitud, lo que limita su eficacia.",
        "<b>Simulador Apollo:</b> Caro, requiere hardware dedicado y operadores especializados.",
        "<b>Aplicación Dart Sim:</b> Solo para Apple, costos elevados de equipo y una interfaz poco fácil de usar."
      ],
      challengesBottomLine : "<strong>En resumen:</strong> las opciones existentes son demasiado costosas, demasiado complicadas o están atrasadas respecto de las últimas pautas clínicas.",
      solutionTitle: "La solución: Resus",
      solutionText: "Presentamos <b>Resus</b>, el software de última generación para la capacitación en emergencias cardíacas.",
      solutionList : [
        "<b>Módulos completos</b>: capacitación exclusiva en RCP, notas rápidas y más, al alcance de su mano.",
        "<b>Características realistas</b>: las simulaciones avanzadas garantizan que la práctica se parezca lo más posible a las emergencias de la vida real."
      ],
      featuresTitle: "¿Por qué elegir nuestra aplicación?",
      featuresList: [
        "<b>Módulo RCP y DEA (exclusivo para Android):</b> Entrene de manera eficaz con los dispositivos que ya posee.",
        "<b>Simulación precisa de fibrilación ventricular:</b> perfeccione sus habilidades con simulaciones de arritmia precisas y de vanguardia.",
        "<b>Interfaz intuitiva:</b> Sin curva de aprendizaje pronunciada; concéntrese en desarrollar habilidades que le salven vidas.",
        "<b>Asequible y accesible:</b> No necesita hardware especializado ni equipos con precios prohibitivos."
      ],
      impactTitle: "Revolucionando la Capacitación Médica",
      impactText: [
        "<b>Salve más vidas</b>",
        "Ofrezca a sus equipos de atención médica herramientas de capacitación prácticas y modernas que los preparen para emergencias cardíacas del mundo real.",
        "",
        "<b>Adaptado a cada entorno</b>",
        "Tanto si trabaja en un hospital de alta tecnología como en una pequeña clínica, Cardio Workbench se adapta perfectamente a su entorno, lo que reduce las brechas de capacitación críticas y hace que la atención de emergencia avanzada sea una realidad para todos.",
      ],
      ctaTitle:"Únase a la revolución en capacitación cardíaca de emergencia",
      ctaList:[
        "Al elegir <b>Resus</b>, no solo obtiene otra herramienta de capacitación, sino que se une a un movimiento para elevar el estándar mundial de preparación para emergencias cardíacas. ¡Prepárese, salve vidas y dé forma al futuro de la capacitación médica!"
      ],
      contact: "Contáctenos: ",
      email:"contact@resusapp.com",
      followUs: "Síganos en redes sociales:",
      comingSoon: "Disponible para teléfonos y tabletas Android",
      
      details: [
        {
          section: "Funciones de Simulación Avanzadas",
          subsections: [
            {name: "12 Ritmos Cardíacos",
              items : ["Domina las interpretaciones de ECG con escenarios realistas y variados."]
            },
            {name: "4 Formas de Curva SpO2",
              items : ["Ajustar y monitorizar diferentes patrones de saturación para cada tipo de paciente."]
            },
            {name: "3 Modelos de Presión Arterial (PAA)",
              items : ["Practique el manejo de presiones variables y aprenda a reaccionar rápidamente a los cambios dinámicos."]
            },
            {name: "EtCO2 y frecuencia respiratoria (FR) ajustables",
              items : ["Simule con precisión las condiciones de ventilación y perfusión."]
            },
          ]
        },
        {
          section: "Funciones Esenciales de Intervención",
          subsections: [
            {name: "Desfibrilador",
              items : [
                "Ajusta la energía del choque según el protocolo y perfecciona tu técnica",
                "Cardioversión sincronizada",
                "Mecanismo de carga y puesta a tierra",
                "Choque reactiva en el ECG",
                "Configuración de energía: 50–360 julios"
              ]
            },
            {name: "Marcapasos",
              items : [
                "Practica el uso de un marcapasos transcutáneo en escenarios realistas",
                "Ajuste de ritmo: 0-200 bpm",
                "Ajuste de corriente: 0-150 mA"
              ]
            },
            {name: "Función de RCP",
              items : ["Simulación de masaje de pecho."]
            },
            {name: "Función NIB",
              items : ["Monitoriza la presión arterial no invasiva de forma rápida y cómoda."]
            },
            {name: "Medicamentos",
              items : ["38 medicamentos disponibles."]
            },
          ]
        },
        {
          section: "Control Total del Paisaje y Otras Funciones",
          subsections: [
            {name: "Crea Tus Propios Escenarios",
              items : ["Personaliza completamente el entorno de simulación para reflejar situaciones reales de tu día a día profesional."]
            },
            {name: "Ajuste Todos Los Signos Vitales",
              items : ["Configure fácilmente parámetros como frecuencia cardíaca, presión arterial, saturación, entre otros, para cada caso clínico."]
            },
            {name: "Alarmas Personalizadas",
              items : ["Identifique rápidamente señales de riesgo y mejore el tiempo de respuesta del equipo."]
            },
            {name: "Botón de Reinicio",
              items : ["Restablecimiento rápido a la configuración predeterminada de la aplicación."]
            },
            {name: "Registro de Eventos",
              items : ["Revise fácilmente las acciones realizadas durante la simulación e identifique oportunidades de mejora."]
            },
          ]
        }
      ],
      carouselsub:'Resus es un simulador de signos vitales en tiempo real, desarrollado para el entrenamiento de profesionales y equipos sanitarios en escenarios clínicos y de emergencia.',
      carousel:[
        "<strong>Muestra signos vitales y formas de onda:</strong> frecuencia cardíaca (FC), saturación de oxígeno (SpO2), presión arterial invasiva (PAI), capnografía (ETCO2) y sus formas de onda, replicando fielmente un monitor de pacientes en reanimación real situaciones.",
        "<strong>Modelos de patología:</strong> incluye numerosos modelos de patología para formas de onda, lo que permite la simulación de una amplia variedad de escenarios clínicos",
        "<strong>Funciones avanzadas:</strong>",
        [
          "Desfibrilador, marcapasos y RCP: herramientas esenciales para el entrenamiento en soporte vital avanzado",
          "Medicamentos y alarmas: Simula respuestas fisiológicas a medicamentos y alertas audibles para situaciones críticas.",
          "Sonidos realistas: emula los sonidos de dispositivos médicos reales para una mayor inmersión en el entrenamiento"],
        "<strong>Registro de eventos:</strong> registra todas las acciones realizadas durante la simulación, lo que facilita la sesión informativa y el análisis del rendimiento.",
        "<strong>Botón de reinicio:</strong> Permite reiniciar rápidamente nuevos escenarios, optimizando el tiempo de entrenamiento.",
        "<strong>Disponibilidad:</strong> Disponible para teléfonos y tabletas Android, ofreciendo practicidad y accesibilidad para los profesionales de la salud"
      ],
      googleform:['Nombre*','Profesión','Especialidad','Empresa','Teléfono','Email*','Comentarios/ Sugerencias/ Solicitudes']
    }
  };

  export default translations